import { useMemo, useState } from "react";
import {
  ListFilterConfig,
  ListFilterConfigItemMultiSelectOption,
  ListFilterConfigItemType,
} from "../../components/list-filter/models";
import useExcursionCities from "../../app/hooks/useExcursionCities";
import useExcursionCompanies from "../../app/hooks/useExcursionCompanies";
import { useTranslation } from "react-i18next";
import useListFilter from "../../components/list-filter/useListFilter";
import useExcursionIndustries from "../../app/hooks/useExcursionIndustries";

export interface ExcursionFilter {
  cities: ListFilterConfigItemMultiSelectOption[];
  online: ListFilterConfigItemMultiSelectOption[];
  companies: ListFilterConfigItemMultiSelectOption[];
  industries: ListFilterConfigItemMultiSelectOption[];
  search: string;
  date: { start: Date; end: Date } | null;
  onlyAvailableSlots?: boolean;
}

const useExcursionFilter = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState<ExcursionFilter>({
    cities: [],
    search: "",
    online: [],
    companies: [],
    industries: [],
    date: null,
  });

  const { cities } = useExcursionCities(value.date);
  const { companyOptions } = useExcursionCompanies(value.date);
  const { industryOptions } = useExcursionIndustries(value.date);

  const config: ListFilterConfig = useMemo(
    () => [
      {
        name: "search",
        title: "excursion.filter.search",
        type: ListFilterConfigItemType.Search,
      },
      {
        name: "cities",
        title: "excursion.filter.cities",
        type: ListFilterConfigItemType.MultiSelect,
        options: cities.map((city) => ({ key: city, value: city, text: city })),
      },
      {
        name: "onlyAvailableSlots",
        title: "shadowings_filter.occupancy_group",
        type: ListFilterConfigItemType.Checkbox,
        label: "shadowings_filter.only_available_slots",
      },
      {
        name: "online",
        title: "excursion.filter.online",
        type: ListFilterConfigItemType.MultiSelect,
        options: [
          {
            key: "online",
            value: "true",
            text: t("excursion.filter.only_online"),
          },
        ],
      },
      {
        name: "companies",
        title: "excursion.filter.companies",
        type: ListFilterConfigItemType.MultiSelect,
        options: companyOptions,
      },
      {
        name: "industries",
        title: "excursion.filter.industries",
        type: ListFilterConfigItemType.MultiSelect,
        options: industryOptions,
      },
      {
        name: "date",
        title: "excursion.filter.date",
        type: ListFilterConfigItemType.DateRange,
      },
    ],
    [cities, companyOptions, industryOptions, t]
  );

  const { renderDeleteBadges, renderSearch, renderFilterAccordion } = useListFilter({
    config,
    value,
    onChange: setValue as any,
  });

  return { value, renderSearch, renderDeleteBadges, renderFilterAccordion };
};

export default useExcursionFilter;
